export default __webpack_public_path__ + "static/media/ratings-review.986431a5.svg";